import { useEffect, useState } from "react";
import { Grid } from '@mui/material';
import CustomTable from "../../../components/common/CustomTable/CustomTable";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { useSpecificAttributeStore } from "../../../hooks/useSpecificAttributeStore";

const columns = [
    { type: 'text', field: 'name', label: 'Nombre', align:'center' },
    { type: 'text', field: 'description', label: 'Descripcion', align:'center' },
];

export const SpecificAttributesModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, useSelected, clearState } = props;

    const { getSpecificAttributesByAttribute } = useSpecificAttributeStore();

    const [loading, setLoading] = useState(false);
    const [specificAttributes, setSpecificAttributes] = useState<any>([]);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);

    useEffect(() => {
        if (useSelected?.id == null) {
            return
        }
        getSpecificAttributesByAttributeApi()
    }, [useSelected?.id])

    const getSpecificAttributesByAttributeApi = async(search='') => {
        try {
            setLoading(true);
            const response = await getSpecificAttributesByAttribute(search, useSelected.id);
            if(!response){
                setSpecificAttributes([]);
                setLoading(false);
                return false;
            }else{
                setSpecificAttributes(response || []);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getSpecificAttributesByAttributeApi(term)}, 1000)
        )
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="md">
            <ModalHeader
                text={'Atributos específicos'}
                className='positionElements'
                onCancel={closeModal}
                clearState = {clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Grid container sx={{padding:'20px'}}>
                    <Grid item container xs={12} spacing={2}>
                        <CustomTable 
                            disabled_title
                            columns={columns} 
                            loading={loading}
                            rows={specificAttributes || []}
                            onRowClick={() => {}}
                            onSearch={onSearch}
                            RowsPerPage={5}
                            dense
                        />
                    </Grid>
                </Grid>
            </ModalBody>
        </Modal>
    )
}